/*
 * Filename: App.tsx
 * Description: This file is the root of project.
 */

import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import Cookies from 'universal-cookie';
import CQLogin from './components/cq-login/login';
import CQSFAuthSuccess from './components/sfAuthSuccess/sfAuthSuccess';
import { CQSFOtherOrgAuthSuccess } from './components/sfOtherOrgAuthSuccess/sfOtherOrgAuthSuccess';
import CQLightningStudioTemplateListContainer from './components/cq-templates/cq-templates-list';
import { CQTemplateConfigurationRoot } from './components/template-configuration/template-configuration-root.component';
import { LoaderComponent } from './common/components/loader-manager/loader-container';
import { PrivateRoute } from './routes/private-route';
import { ICQAppStore, CQAppStore } from './store/cq-app-store';
import { CQAppConstant } from './app-constants';
import './assets/slds/styles/salesforce-lightning-design-system.css';
import './App.css';
import  ErrorManagerComponent  from './common/components/error-manager/error-manager.component';
import { SuccessManagerComponent } from './common/components/success-manager/success-manager.component';
import { InformationManagerComponent } from './common/components/information-manager/information-manager.component';

interface IAppProps {
  store: ICQAppStore
}

const cookie = new Cookies();
@inject('store')
@observer
class App extends React.Component<{}> {
  render() {
    return (
      <>
        <Router>
          <Switch>
            <Route exact path={CQAppConstant.NAVIGATION.DEFAULT_PATH}
              render={props =>
                <CQLogin {...props}
                  setAccessToken={CQAppStore.authentication.setAccessToken}
                  jwtAccessToken={CQAppStore.authentication.jwtAccessToken}
                  fetchJWTAccessToken={CQAppStore.authentication.fetchJWTAccessToken}
                  cookie={cookie}
                  accessToken={CQAppStore.authentication.accessToken}
                  setIsUserLoggedIn={CQAppStore.authentication.setIsUserLoggedIn}
                />}
            />
            {/* <Route exact path={CQAppConstant.NAVIGATION.DEFAULT_PATH}
              render={props => <CQTemplateConfigurationRoot /> } /> */}

            <Route exact path={CQAppConstant.NAVIGATION.AUTH_SUCCESS_CALLBACK}>
              <CQSFAuthSuccess />
            </Route>
            <Route exact path={CQAppConstant.NAVIGATION.OTHER_ORG_AUTH_SUCCESS_CALLBACK}>
              <CQSFOtherOrgAuthSuccess />
            </Route>
            <PrivateRoute path={CQAppConstant.NAVIGATION.TEMPLATES} component={CQLightningStudioTemplateListContainer} />
            <PrivateRoute path={CQAppConstant.NAVIGATION.TEMPLATES_CONFIGURATION} component={CQTemplateConfigurationRoot} />
            <Route path="*" children={<h3>No Match Found</h3>} />
          </Switch>
          <SuccessManagerComponent />
          <LoaderComponent />
          <ErrorManagerComponent />
          <InformationManagerComponent />
        </Router>
      </>
    );
  }
}
export default App;
